import React from 'react';
import PropTypes from 'prop-types';
export default function Group(props) {
  return (
    <svg width={props.width} height={props.width} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props} >
      <path
        d='M10.75 19C10.75 19 9.5 19 9.5 17.75C9.5 16.5 10.75 12.75 15.75 12.75C20.75 12.75 22 16.5 22 17.75C22 19 20.75 19 20.75 19H10.75ZM15.75 11.5C16.7446 11.5 17.6984 11.1049 18.4017 10.4017C19.1049 9.69839 19.5 8.74456 19.5 7.75C19.5 6.75544 19.1049 5.80161 18.4017 5.09835C17.6984 4.39509 16.7446 4 15.75 4C14.7554 4 13.8016 4.39509 13.0983 5.09835C12.3951 5.80161 12 6.75544 12 7.75C12 8.74456 12.3951 9.69839 13.0983 10.4017C13.8016 11.1049 14.7554 11.5 15.75 11.5Z'
        fill={props.color || '#8E8E92'}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.52 19C8.33469 18.6097 8.24228 18.1819 8.25 17.75C8.25 16.0562 9.1 14.3125 10.67 13.1C9.88636 12.8585 9.06993 12.7404 8.25 12.75C3.25 12.75 2 16.5 2 17.75C2 19 3.25 19 3.25 19H8.52Z'
        fill={props.color || '#8E8E92'}
      />
      <path
        d='M7.625 11.5C8.4538 11.5 9.24866 11.1708 9.83471 10.5847C10.4208 9.99866 10.75 9.2038 10.75 8.375C10.75 7.5462 10.4208 6.75134 9.83471 6.16529C9.24866 5.57924 8.4538 5.25 7.625 5.25C6.7962 5.25 6.00134 5.57924 5.41529 6.16529C4.82924 6.75134 4.5 7.5462 4.5 8.375C4.5 9.2038 4.82924 9.99866 5.41529 10.5847C6.00134 11.1708 6.7962 11.5 7.625 11.5Z'
        fill={props.color || '#8E8E92'}
      />
    </svg>
  );
}

Group.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number
};

Group.defaultProps = {
  color: '#000',
  width: 20
};
